import React from 'react';
const baseStyle = { display: 'block' };

function IconBase({ children, style, ...props }) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ ...baseStyle, ...style }}
            {...props}
        >
            {children}
        </svg>
    );
}

export function AboutIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M3.39451 22.4601C2.48826 20.9771 2.96581 16.1365 6.71195 15.5667C10.8319 14.9401 17.1181 14.94 18.4864 14.94H18.488C19.8339 14.94 20.8977 15.6035 20.9896 16.7064C21.052 17.4555 20.8604 20.0704 19.6656 22.4601M11.4224 11.9955C14.3664 12.5848 17.8992 8.46316 16.7216 4.92947C15.1752 0.289142 10.2448 1.39658 9.09992 2.54816C7.67891 3.61393 6.71195 6.69628 8.47839 10.2291"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}

export function GitHubIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M10.4888 22.6672C9.35419 20.9217 9.27871 20.0254 9.33981 18.681C7.88751 18.9336 5.65337 19.1959 4.92009 16.7517C4.79279 16.1406 4.09992 14.7702 3 14.7091C3.81476 14.6327 5.31039 14.4799 6.13172 15.5493C7.1893 16.9262 10.6383 17.4589 10.3328 14.4799M8.11894 13.6616C6.52375 13.4388 4.80103 8.92178 7.17091 6.55188M7.64489 3.9386C7.54305 3.4803 8.1253 1.18532 8.59287 1.34052C9.5951 1.67319 11.4367 3.70748 11.4367 3.70748C12.0477 3.55471 15.4066 3.32753 16.3843 3.9386C16.3843 3.9386 19.3154 1.34052 19.9684 1.81196C20.6214 2.2834 19.9684 5.60392 19.9684 5.60392C21.3903 7.02586 20.9344 9.75046 20.9164 9.86974C20.7009 11.2917 19.4048 14.002 15.7026 14.6095C16.1766 16.0315 16.6505 18.8754 16.1766 21.7193"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}

export function LinkedInIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M2 11L1.83368 18.8957C1.83368 19.6001 2.02388 20.9878 2.78466 20.9033C3.73564 20.7976 4.26397 20.7976 5.00362 21.326C5.74327 21.8543 6.44415 16.2384 6.33368 13.8081C6.25683 12.1175 5.9546 10.3935 6.16593 8.59717C5.35584 8.84372 3.76079 9.16906 3 9M11.7534 7.80811H14L13.9564 9.30811C16 8 18.5659 8.04034 20.3337 9.80811C22.3337 11.8081 22.7425 18.1382 21.3337 21.3081L17.8457 21.4806C17.8457 21.4806 18.1955 19.1044 18.3337 17.3081C18.4393 15.9345 19.1929 13.2137 16.3337 13.3081C15.0896 13.3492 14.3337 14.3081 13.5625 15.035V21.6919C12.4002 20.8466 10.4982 20.7761 9.54721 21.2692C9.21327 16.761 10.1238 12.3046 9.83368 7.80811M2.62994 7.00443C2.13684 6.40566 1.3831 4.84887 2.31295 3.41183C3.47526 1.61553 5.69422 2.24951 5.69422 3.62316C5.69422 4.9968 4.21492 7.53277 2.62994 7.00443Z"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}

export function MailIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M4.35872 5L3.94567 18.9995C5.33443 18.498 8.82366 18.0322 12.6196 18.2174C16.4155 18.4026 19.1944 18.1243 20.4674 17.3913M2.70654 7.06522C6.42394 6.65217 15.141 5.00008 17.1631 5C19.6413 4.9999 21.2935 5.77666 21.2935 8.30423C21.2935 10.3694 21.1778 12.5824 21.2935 14.0868M6.01089 9.13044L10.5544 12.8478C11.2943 13.5289 12.7463 13.4756 14.6848 12.0217C16.337 10.7826 18.7926 9.26876 19.6413 8.30435"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}

export function MediumIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M4.25434 19.8667C4.78675 16.4593 5.45225 7.98338 4.81337 4.53339M6.56967 9.15663L10.6492 19.4548C10.6492 19.4548 12.5268 13.4838 14.3796 10.9283C16.2323 8.37272 15.9783 4.90558 15.9783 4.00049M3.72144 5.0663C6.38597 6.13211 7.52561 5.16376 7.60547 4.76446L13.3137 16.7902M17.1888 9.39646L17.0441 19.9877C17.3902 20.0942 19.7086 19.4548 19.7086 19.4548C20.3209 15.5948 20.6031 6.85518 19.7086 5.0663"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}

export function MoreIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M10.6416 4.83401C10.8882 6.0812 12.6136 6.35285 13.333 4.83401C14.148 3.11353 13.3985 2.15345 12.6086 2.09704C11.7635 2.03666 10.7976 2.00648 10.6416 3.11353M10.6416 12.8019C10.2544 11.9665 10.6779 9.9043 11.9093 9.9043C13.4487 9.9043 14.3223 11.6493 13.5142 12.9625C12.7898 14.1397 11.7937 13.979 11.1849 13.979M11.6126 21.9271C10.6166 21.8365 9.56296 20.5688 10.6166 19.1201C11.7756 17.5264 13.2991 17.8344 13.6298 18.7783C13.8764 19.4823 13.5142 20.5688 12.8148 20.8609"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}

export function ResumeIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M3.11761 17.6642C2.67639 14.1642 3.23538 8.13243 2.61774 6.46443C6.08342 4.64581 12.2529 4.50526 16.6176 5.16408C20.9823 5.8229 21.1176 7.15561 21.1176 8.16406C21.1176 10.1641 21.1176 12.1641 20.1176 14.6641M7.49988 10.5258C10.0048 9.83949 14.7114 8.76167 15.0146 9.70224C15.2205 10.3409 14.3969 10.8556 14.3969 10.8556M6.11759 15.6427C9.09672 14.7971 14.7473 13.5213 17.1176 14.6641M5.11761 19.1618C7.48526 19.2305 12.6782 19.2526 15.6176 18.6643C18.1176 18.1641 20.6617 18.103 21.3823 18.3089"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}

export function MoonIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M12.9531 13.8878C9.65715 12.4752 8.16898 9.17931 10.5232 4C6.28567 4 0.920249 11.5335 6.36124 17.6546C10.5232 22.3367 19.4694 19.5379 19.9402 13.4169C18.0568 14.3586 17.1907 13.8878 17.1907 13.8878"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}

export function SunIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M8.44444 10.2047C7.1555 12.353 7.95834 15.6118 11.0891 16.2771C15.2002 17.1508 16.5254 13.0158 16.1704 11.6663C15.9992 10.1496 14.1362 8.09174 10.7499 7.86306M12.3112 5.04898V1.70947M16.6077 6.76756L19.1856 5.04898M18.3263 12.7826L22 13.0525M16.6077 17.079L17.8966 20.0866M11.452 18.7976L10.7499 22.2907M6.72585 16.2198L3.71834 18.7976M4.57763 11.9233H1.99976M7.58514 5.90827L6.29621 3.3304"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
            />
        </IconBase>
    );
}

export function ArrowIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M4.08911 20.0002C4.10287 19.9864 4.11663 19.9725 5.18809 18.8768C9.37974 14.5901 12.2848 10.1256 17.3806 8.42704M5.98649 5.82129H8.17858C10.3542 5.82129 14.697 5.82129 16.9444 5.8628C19.1917 5.90431 19.2119 5.98733 19.304 7.8748C19.396 9.76227 19.2315 16.9041 19.9109 18.9424"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
            />
        </IconBase>
    );
}

/** Back to home — case-study and about routes. */
export function BackIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M21.3217 12.2513C21.3046 12.2505 21.2875 12.2498 19.947 12.1814C14.7029 11.9138 9.46963 10.998 5.09054 11.4359M9.38971 4.68213C7.98983 5.97485 5.19551 8.55527 3.77418 9.91729C2.35284 11.2793 2.38916 11.3447 3.45143 12.6139C4.5137 13.8831 8.25784 17.6031 9.03178 19.3183"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
            />
        </IconBase>
    );
}

/** Code brackets — use for “show source” toggles. */
export function CodeIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M8 6.5C7.99554 6.50148 7.99107 6.50296 7.55744 6.90314C7.1238 7.30332 6.26113 8.10215 5.26108 8.96961C4.26103 9.83706 3.14974 10.7489 2.51338 11.2869C1.73985 11.9409 1.56781 12.1699 1.40237 12.4376C1.28208 12.6322 1.10707 12.9676 1.02627 13.1507C0.945469 13.3337 0.969052 13.3597 2.33803 14.1858C3.70701 15.0118 6.42067 16.6372 7.87268 17.5M14.5 6C14.5 6.01118 14.4381 6.2126 13.8222 7.78909C13.2794 9.1783 12.2239 11.73 11.5482 13.5052C10.8725 15.2804 10.5971 16.1933 10.4463 16.6998C10.2775 17.2791 10.2242 17.4468 10.1461 17.6477C10.1028 17.7557 10.0522 17.876 10 17.9999M16.9659 7.5C17.0411 7.5 17.3203 7.53051 18.5002 8.39919C19.1249 8.85906 19.9946 9.8804 20.6666 10.6312C21.3386 11.3819 21.7484 11.9203 22.068 12.3282C22.599 13.0056 22.8704 13.3123 22.9559 13.4082C22.9997 13.4573 23.0433 13.5082 22.9152 13.6661C22.7871 13.8239 22.4859 14.0874 21.4163 14.6003C20.3467 15.1133 18.5179 15.8676 17.3925 16.386C15.9005 17.1641 15.3859 17.5629 15.1607 17.7899C15.0724 17.8856 15.0367 17.942 15 18"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
            />
        </IconBase>
    );
}

/** Motion path — use for “show animation” toggles. */
export function AnimationIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M8.1372 6.60673C8.27188 6.64662 10.0274 7.61407 12.6232 9.26156C15.9313 11.361 16.5669 12.5219 16.6657 12.7088C16.7032 12.7798 16.5545 12.84 15.2071 13.6923C13.8597 14.5445 11.277 16.1967 9.92588 16.9832C8.57477 17.7698 8.53349 17.6407 8.50836 16.8393C8.48322 16.038 8.47549 14.5683 8.53251 13.4301C8.58952 12.2919 8.71152 11.5298 8.7763 10.7804M20.4248 16.79C18.0356 20.5445 8.47891 26.3468 3.3592 16.79C0.982323 12.3529 1.58642 4.1779 8.4789 2.45497C16.6706 0.407273 22.8142 5.52679 21.7901 12.6944"
                stroke="currentColor"
                strokeWidth="1.66"
                strokeLinecap="round"
            />
        </IconBase>
    );
}

/** Check mark — iteration / feedback success (green). */
export function CheckIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M1.97522 14.6384C2.41327 14.8204 7.53953 18.2422 10.3098 19.9998C10.5813 19.3549 12.1931 16.3644 15.8075 11.082C17.9256 8.2868 18.8141 7.46487 22.0247 3.99951"
                stroke="var(--color-icon-success)"
                strokeWidth="1.66"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconBase>
    );
}

/** X mark — iteration / feedback failure (red). */
export function XIcon(props) {
    return (
        <IconBase {...props}>
            <path
                d="M20.922 2.53076C20.6756 2.57915 19.3005 3.21419 16.7556 5.05644C15.058 6.28537 12.7699 8.41981 10.9854 10.1665C9.20097 11.9133 8.04932 13.2864 6.8357 14.9822C5.62207 16.678 4.38136 18.6547 3.67571 19.762C2.97006 20.8693 2.83706 21.0472 2.57836 21.4693M2.49976 3.09081C9.24047 8.04443 16.7556 14.9822 21.5 19.762"
                stroke="var(--color-icon-error)"
                strokeWidth="1.66"
                strokeLinecap="round"
            />
        </IconBase>
    );
}
